import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { postulationStateEnum } from '@app/enums/postulationState.enum';
import { Postulation } from '@app/models/firebase/postulation';
import { AuthService } from '@app/services/auth/auth.service';
import { PostulationService } from '@app/services/postulation/postulation.service';
import { SpinnerService } from '@app/services/spinner/spinner.service';
import { ToasterService } from '@app/services/toaster/toaster.service';

@Component({
    selector: 'app-postulated-form',
    templateUrl: './postulated-form.component.html',
    styleUrls: ['./postulated-form.component.scss'],
    standalone: false
})
export class PostulatedFormComponent implements OnInit {

  model: Postulation = new Postulation()
  postulationId: string = null;
  type: any = null;
  jobOfferId: string = null;
  postulationState = postulationStateEnum;
  isDisable = false;

  constructor(
    protected authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private postulationService: PostulationService,
    private spinnerService: SpinnerService,
    private toasterService: ToasterService,
    private translateService: TranslateService
  ) { }

  async ngOnInit(): Promise<void> {
    this.spinnerService.show();
    this.activatedRoute.params.subscribe(async params => {
      this.jobOfferId = params['jobOfferId'];
      this.postulationId = params['postulationId'];
      this.type = params['type'];
    });
    this.model = await this.postulationService.getPostulation(this.authService.projectId, this.postulationId, this.jobOfferId);
    this.spinnerService.hide();
    this.isDisable = this.model.rejectNote != null;
  }

  async save() {
    this.spinnerService.show();
    this.model.state = this.type;
    await this.postulationService.save(this.model, this.authService.projectId),
    this.spinnerService.hide();
    this.toasterService.show(this.translateService.instant('langs.toaster_information_saved_successfully'), "Ok");
    this.isDisable = true;
  }

}
